import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  /*{
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },*/
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/client',
    name: 'Benvenuto',
    component: () => import('../views/Benvenuto.vue')
  },
  {
    path: '/menu',
    name: 'Menu',
    component: () => import('../views/Menu.vue')
  },
  {
    path: '/changelayout',
    name: 'ChangeLayout',
    component: () => import('../views/ChangeLayout.vue')
  },
  {
    path: '/ordine-asporto',
    name: 'OrdineAsporto',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/OrdineAsporto.vue')
  },
  {
    path: '/pagamento-successo',
    name: 'PagamentoSuccesso',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/PagamentoSuccesso.vue')
  },
  {
    path: '/pagamento-fallito',
    name: 'PagamentoFallito',
    component: () => import(/* webpackChunkName: "asporto" */ '../views/PagamentoFallito.vue')
  },
  {
    path: '/prenota-tavolo',
    name: 'PrenotaTavolo',
    component: () => import(/* webpackChunkName: "about" */ '../views/PrenotaTavolo.vue')
  }
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
